export default "__VITE_ASSET__CsJKXamx__"